/*
 *
 * TeamAnalysis constants
 *
 */

export const DEFAULT_ACTION = "app/TeamAnalysis/DEFAULT_ACTION"

export const GET_DRILLDOWN_DIVISIONS_WATCHER =
  "app/TeamAnalysis/GET_DRILLDOWN_DIVISIONS_WATCHER"
export const GET_DRILLDOWN_DIVISIONS_SUCCESS =
  "app/TeamAnalysis/GET_DRILLDOWN_DIVISIONS_SUCCESS"
export const GET_DRILLDOWN_DIVISIONS_FAILED =
  "app/TeamAnalysis/GET_DRILLDOWN_DIVISIONS_FAILED"

export const GET_DIMENSIONS_WATCHER = "app/TeamAnalysis/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS = "app/TeamAnalysis/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED = "app/TeamAnalysis/GET_DIMENSIONS_FAILED"

export const GET_TEAMS_WATCHER = "app/TeamAnalysis/GET_TEAMS_WATCHER"
export const GET_TEAMS_SUCCESS = "app/TeamAnalysis/GET_TEAMS_SUCCESS"
export const GET_TEAMS_FAILED = "app/TeamAnalysis/GET_TEAMS_FAILED"

export const GET_GRAPHIC_BAR_WATCHER =
  "app/TeamAnalysis/GET_GRAPHIC_BAR_WATCHER"
export const GET_GRAPHIC_BAR_SUCCESS =
  "app/TeamAnalysis/GET_GRAPHIC_BAR_SUCCESS"
export const GET_GRAPHIC_BAR_FAILED = "app/TeamAnalysis/GET_GRAPHIC_BAR_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/TeamAnalysis/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/TeamAnalysis/GET_MEASURE_COLOR_RANGE_SUCCESS"
